export const countries = [
    { name: "United States", id: "US" },
    { name: "United States Minor Outlying Islands", id: "UM" },
    { name: "United Kingdom", id: "GB" },
    { name: "Andorra", id: "AD" },
    { name: "United Arab Emirates", id: "AE" },
    { name: "Afghanistan", id: "AF" },
    { name: "Antigua and Barbuda", id: "AG" },
    { name: "Anguilla", id: "AI" },
    { name: "Albania", id: "AL" },
    { name: "Armenia", id: "AM" },
    { name: "Angola", id: "AO" },
    { name: "Antarctica", id: "AQ" },
    { name: "Argentina", id: "AR" },
    { name: "American Samoa", id: "AS" },
    { name: "Austria", id: "AT" },
    { name: "Australia", id: "AU" },
    { name: "Aruba", id: "AW" },
    { name: "Åland Islands", id: "AX" },
    { name: "Azerbaijan", id: "AZ" },
    { name: "Bosnia and Herzegovina", id: "BA" },
    { name: "Barbados", id: "BB" },
    { name: "Bangladesh", id: "BD" },
    { name: "Belgium", id: "BE" },
    { name: "Burkina Faso", id: "BF" },
    { name: "Bulgaria", id: "BG" },
    { name: "Bahrain", id: "BH" },
    { name: "Burundi", id: "BI" },
    { name: "Benin", id: "BJ" },
    { name: "Saint Barthélemy", id: "BL" },
    { name: "Bermuda", id: "BM" },
    { name: "Brunei Darussalam", id: "BN" },
    { name: "Bolivia (Plurinational State of)", id: "BO" },
    { name: "Bonaire, Sint Eustatius and Saba", id: "BQ" },
    { name: "Brazil", id: "BR" },
    { name: "Bahamas", id: "BS" },
    { name: "Bhutan", id: "BT" },
    { name: "Bouvet Island", id: "BV" },
    { name: "Botswana", id: "BW" },
    { name: "Belarus", id: "BY" },
    { name: "Belize", id: "BZ" },
    { name: "Canada", id: "CA" },
    { name: "Cocos (Keeling) Islands", id: "CC" },
    { name: "Congo (the Democratic Republic of the)", id: "CD" },
    { name: "Central African Republic", id: "CF" },
    { name: "Congo", id: "CG" },
    { name: "Switzerland", id: "CH" },
    { name: "Côte d'Ivoire", id: "CI" },
    { name: "Cook Islands", id: "CK" },
    { name: "Chile", id: "CL" },
    { name: "Cameroon", id: "CM" },
    { name: "China", id: "CN" },
    { name: "Colombia", id: "CO" },
    { name: "Costa Rica", id: "CR" },
    { name: "Cuba", id: "CU" },
    { name: "Cabo Verde", id: "CV" },
    { name: "Curaçao", id: "CW" },
    { name: "Christmas Island", id: "CX" },
    { name: "Cyprus", id: "CY" },
    { name: "Czechia", id: "CZ" },
    { name: "Germany", id: "DE" },
    { name: "Djibouti", id: "DJ" },
    { name: "Denmark", id: "DK" },
    { name: "Dominica", id: "DM" },
    { name: "Dominican Republic", id: "DO" },
    { name: "Algeria", id: "DZ" },
    { name: "Ecuador", id: "EC" },
    { name: "Estonia", id: "EE" },
    { name: "Egypt", id: "EG" },
    { name: "Western Sahara", id: "EH" },
    { name: "Eritrea", id: "ER" },
    { name: "Spain", id: "ES" },
    { name: "Ethiopia", id: "ET" },
    { name: "Finland", id: "FI" },
    { name: "Fiji", id: "FJ" },
    { name: "Falkland Islands (Malvinas)", id: "FK" },
    { name: "Micronesia (Federated States of)", id: "FM" },
    { name: "Faroe Islands", id: "FO" },
    { name: "France", id: "FR" },
    { name: "Gabon", id: "GA" },
    { name: "Grenada", id: "GD" },
    { name: "Georgia", id: "GE" },
    { name: "French Guiana", id: "GF" },
    { name: "Guernsey", id: "GG" },
    { name: "Ghana", id: "GH" },
    { name: "Gibraltar", id: "GI" },
    { name: "Greenland", id: "GL" },
    { name: "Gambia", id: "GM" },
    { name: "Guinea", id: "GN" },
    { name: "Guadeloupe", id: "GP" },
    { name: "Equatorial Guinea", id: "GQ" },
    { name: "Greece", id: "GR" },
    { name: "South Georgia and the South Sandwich Islands", id: "GS" },
    { name: "Guatemala", id: "GT" },
    { name: "Guam", id: "GU" },
    { name: "Guinea-Bissau", id: "GW" },
    { name: "Guyana", id: "GY" },
    { name: "Hong Kong", id: "HK" },
    { name: "Heard Island and McDonald Islands", id: "HM" },
    { name: "Honduras", id: "HN" },
    { name: "Croatia", id: "HR" },
    { name: "Haiti", id: "HT" },
    { name: "Hungary", id: "HU" },
    { name: "Indonesia", id: "ID" },
    { name: "Ireland", id: "IE" },
    { name: "Israel", id: "IL" },
    { name: "Isle of Man", id: "IM" },
    { name: "India", id: "IN" },
    { name: "British Indian Ocean Territory", id: "IO" },
    { name: "Iraq", id: "IQ" },
    { name: "Iran (Islamic Republic of)", id: "IR" },
    { name: "Iceland", id: "IS" },
    { name: "Italy", id: "IT" },
    { name: "Jersey", id: "JE" },
    { name: "Jamaica", id: "JM" },
    { name: "Jordan", id: "JO" },
    { name: "Japan", id: "JP" },
    { name: "Kenya", id: "KE" },
    { name: "Kyrgyzstan", id: "KG" },
    { name: "Cambodia", id: "KH" },
    { name: "Kiribati", id: "KI" },
    { name: "Comoros", id: "KM" },
    { name: "Saint Kitts and Nevis", id: "KN" },
    { name: "Korea (the Democratic People's Republic of)", id: "KP" },
    { name: "Korea (the Republic of)", id: "KR" },
    { name: "Kuwait", id: "KW" },
    { name: "Cayman Islands", id: "KY" },
    { name: "Kazakhstan", id: "KZ" },
    { name: "Lao People's Democratic Republic", id: "LA" },
    { name: "Lebanon", id: "LB" },
    { name: "Saint Lucia", id: "LC" },
    { name: "Liechtenstein", id: "LI" },
    { name: "Sri Lanka", id: "LK" },
    { name: "Liberia", id: "LR" },
    { name: "Lesotho", id: "LS" },
    { name: "Lithuania", id: "LT" },
    { name: "Luxembourg", id: "LU" },
    { name: "Latvia", id: "LV" },
    { name: "Libya", id: "LY" },
    { name: "Morocco", id: "MA" },
    { name: "Monaco", id: "MC" },
    { name: "Moldova (the Republic of)", id: "MD" },
    { name: "Montenegro", id: "ME" },
    { name: "Saint Martin (French part)", id: "MF" },
    { name: "Madagascar", id: "MG" },
    { name: "Marshall Islands", id: "MH" },
    { name: "North Macedonia", id: "MK" },
    { name: "Mali", id: "ML" },
    { name: "Myanmar", id: "MM" },
    { name: "Mongolia", id: "MN" },
    { name: "Macao", id: "MO" },
    { name: "Northern Mariana Islands", id: "MP" },
    { name: "Martinique", id: "MQ" },
    { name: "Mauritania", id: "MR" },
    { name: "Montserrat", id: "MS" },
    { name: "Malta", id: "MT" },
    { name: "Mauritius", id: "MU" },
    { name: "Maldives", id: "MV" },
    { name: "Malawi", id: "MW" },
    { name: "Mexico", id: "MX" },
    { name: "Malaysia", id: "MY" },
    { name: "Mozambique", id: "MZ" },
    { name: "Namibia", id: "NA" },
    { name: "New Caledonia", id: "NC" },
    { name: "Niger", id: "NE" },
    { name: "Norfolk Island", id: "NF" },
    { name: "Nigeria", id: "NG" },
    { name: "Nicaragua", id: "NI" },
    { name: "Netherlands", id: "NL" },
    { name: "Norway", id: "NO" },
    { name: "Nepal", id: "NP" },
    { name: "Nauru", id: "NR" },
    { name: "Niue", id: "NU" },
    { name: "New Zealand", id: "NZ" },
    { name: "Oman", id: "OM" },
    { name: "Panama", id: "PA" },
    { name: "Peru", id: "PE" },
    { name: "French Polynesia", id: "PF" },
    { name: "Papua New Guinea", id: "PG" },
    { name: "Philippines", id: "PH" },
    { name: "Pakistan", id: "PK" },
    { name: "Poland", id: "PL" },
    { name: "Saint Pierre and Miquelon", id: "PM" },
    { name: "Pitcairn", id: "PN" },
    { name: "Puerto Rico", id: "PR" },
    { name: "Palestine, State of", id: "PS" },
    { name: "Portugal", id: "PT" },
    { name: "Palau", id: "PW" },
    { name: "Paraguay", id: "PY" },
    { name: "Qatar", id: "QA" },
    { name: "Réunion", id: "RE" },
    { name: "Romania", id: "RO" },
    { name: "Serbia", id: "RS" },
    { name: "Russian Federation", id: "RU" },
    { name: "Rwanda", id: "RW" },
    { name: "Saudi Arabia", id: "SA" },
    { name: "Solomon Islands", id: "SB" },
    { name: "Seychelles", id: "SC" },
    { name: "Sudan", id: "SD" },
    { name: "Sweden", id: "SE" },
    { name: "Singapore", id: "SG" },
    { name: "Saint Helena, Ascension and Tristan da Cunha", id: "SH" },
    { name: "Slovenia", id: "SI" },
    { name: "Svalbard and Jan Mayen", id: "SJ" },
    { name: "Slovakia", id: "SK" },
    { name: "Sierra Leone", id: "SL" },
    { name: "San Marino", id: "SM" },
    { name: "Senegal", id: "SN" },
    { name: "Somalia", id: "SO" },
    { name: "Suriname", id: "SR" },
    { name: "South Sudan", id: "SS" },
    { name: "Sao Tome and Principe", id: "ST" },
    { name: "El Salvador", id: "SV" },
    { name: "Sint Maarten (Dutch part)", id: "SX" },
    { name: "Syrian Arab Republic", id: "SY" },
    { name: "Eswatini", id: "SZ" },
    { name: "Turks and Caicos Islands", id: "TC" },
    { name: "Chad", id: "TD" },
    { name: "French Southern Territories", id: "TF" },
    { name: "Togo", id: "TG" },
    { name: "Thailand", id: "TH" },
    { name: "Tajikistan", id: "TJ" },
    { name: "Tokelau", id: "TK" },
    { name: "Timor-Leste", id: "TL" },
    { name: "Turkmenistan", id: "TM" },
    { name: "Tunisia", id: "TN" },
    { name: "Tonga", id: "TO" },
    { name: "Türkiye", id: "TR" },
    { name: "Trinidad and Tobago", id: "TT" },
    { name: "Tuvalu", id: "TV" },
    { name: "Taiwan (Province of China)", id: "TW" },
    { name: "Tanzania, the United Republic of", id: "TZ" },
    { name: "Ukraine", id: "UA" },
    { name: "Uganda", id: "UG" },
    { name: "Uruguay", id: "UY" },
    { name: "Uzbekistan", id: "UZ" },
    { name: "Holy See", id: "VA" },
    { name: "Saint Vincent and the Grenadines", id: "VC" },
    { name: "Venezuela (Bolivarian Republic of)", id: "VE" },
    { name: "Virgin Islands (British)", id: "VG" },
    { name: "Virgin Islands (U.S.)", id: "VI" },
    { name: "Viet Nam", id: "VN" },
    { name: "Vanuatu", id: "VU" },
    { name: "Wallis and Futuna", id: "WF" },
    { name: "Samoa", id: "WS" },
    { name: "Kosovo", id: "XK" },
    { name: "Yemen", id: "YE" },
    { name: "Mayotte", id: "YT" },
    { name: "South Africa", id: "ZA" },
    { name: "Zambia", id: "ZM" },
    { name: "Zimbabwe", id: "ZW" },
];

export const softwareLanguages = [
    { language: "English", short: "en" },
    { language: "Français", short: "fr" },
    { language: "Deutsch", short: "de" },
    { language: "Español", short: "es" },
    { language: "Italiano", short: "it" },
    { language: "日本語 (Japanese)", short: "ja" },
    { language: "한국어 (Korean)", short: "ko" },
    { language: "Polski", short: "pl" },
    { language: "Português", short: "pt" },
    { language: "中文 (Chinese)", short: "zh" },
];

export const marketingLanguages = [
    { language: "English", short: "en" },
    { language: "Français", short: "fr" },
    { language: "Deutsch", short: "de" },
    { language: "Español", short: "es" },
    { language: "Italiano", short: "it" },
    { language: "日本語 (Japanese)", short: "ja" },
    { language: "Polski", short: "pl" },
];
